<ng-container *ngIf="dayHeaderContents$ | async as dayHeaderContents">
  <div class="fc-col-header-cell-cushion-container">
    <div>
      <span class="fc-col-header-cell-cushion-day">{{ dayHeaderContents.day }} </span>
      <span class="fc-col-header-cell-cushion-date">{{ dayHeaderContents.date }}</span>
    </div>
  </div>
</ng-container>
